import { render, staticRenderFns } from "./officialaccountList.vue?vue&type=template&id=aab0ddfc&scoped=true"
import script from "./officialaccountList.vue?vue&type=script&lang=js"
export * from "./officialaccountList.vue?vue&type=script&lang=js"
import style0 from "./officialaccountList.vue?vue&type=style&index=0&id=aab0ddfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab0ddfc",
  null
  
)

export default component.exports